import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';


import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import SLAReports from './SLAReports.vue';
// Demo: painéis FanData travados como "EM BREVE" — renderizam o placeholder
// (a tela real não monta, nenhuma chamada de API). Para destravar, voltar o
// component de cada rota para o painel real (FarolPanel/CriticidadePanel/...).
import EmBreve from 'dashboard/components/fandata/EmBreve.vue';
import FarolPanel from './FarolPanel.vue';
import QuebrasPanel from './QuebrasPanel.vue';
import VisaoGeralPanel from './VisaoGeralPanel.vue';
import BotImpactPanel from './BotImpactPanel.vue';
import SatisfacaoPanel from './SatisfacaoPanel.vue';
import PendenciaPanel from './PendenciaPanel.vue';
import PresencaPanel from './PresencaPanel.vue';
import JourneyPanel from './JourneyPanel.vue';

// Gating "EM BREVE" por ambiente (runtime): demo trava; dev/prod mostram o painel real.
const gated = ['true', true].includes(window.globalConfig?.FANDATA_DEMO_GATING);

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    // T-151: as quatro visões gerais viraram a página única de Quebras. A rota fica de pé e
    // redireciona com a dimensão certa, para link antigo não morrer.
    path: 'agents_overview',
    name: 'agent_reports_index',
    redirect: to => ({
      name: 'quebras_reports',
      params: to.params,
      query: { dim: 'agent' },
    }),
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    // T-151: as quatro visões gerais viraram a página única de Quebras. A rota fica de pé e
    // redireciona com a dimensão certa, para link antigo não morrer.
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    redirect: to => ({
      name: 'quebras_reports',
      params: to.params,
      query: { dim: 'inbox' },
    }),
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    // T-151: as quatro visões gerais viraram a página única de Quebras. A rota fica de pé e
    // redireciona com a dimensão certa, para link antigo não morrer.
    path: 'teams_overview',
    name: 'team_reports_index',
    redirect: to => ({
      name: 'quebras_reports',
      params: to.params,
      query: { dim: 'team' },
    }),
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    // T-151: as quatro visões gerais viraram a página única de Quebras. A rota fica de pé e
    // redireciona com a dimensão certa, para link antigo não morrer.
    path: 'labels_overview',
    name: 'label_reports_index',
    redirect: to => ({
      name: 'quebras_reports',
      params: to.params,
      query: { dim: 'label' },
    }),
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          // T-149: a Visão Geral passou a ser os dez indicadores do período. A antiga (ao vivo,
          // com status de agente e mapas de calor) virou a aba "Ao vivo" desta mesma página:
          // "como foi o período" e "como está agora" são perguntas diferentes, do mesmo lugar.
          //
          // NÃO entra no gating da demo, de propósito: a Visão Geral já existia e some ninguém
          // deve perder tela que já usa. O que é novo aqui é a primeira aba.
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: VisaoGeralPanel,
        },
        {
          path: 'farol',
          name: 'farol_reports',
          meta: { ...meta, emBreveTitulo: 'Farol' },
          component: gated ? EmBreve : FarolPanel,
        },
        {
          // T-150b: a Criticidade virou aba do Farol. A rota fica de pé e redireciona, porque
          // link antigo em e-mail e em documento não pode cair em página branca.
          path: 'criticidade',
          name: 'criticidade_reports',
          redirect: to => ({
            name: 'farol_reports',
            params: to.params,
            query: { aba: 'critica' },
          }),
        },
        {
          path: 'bot_impact',
          name: 'bot_impact_reports',
          meta: { ...meta, emBreveTitulo: 'Atendimento da IA' },
          component: gated ? EmBreve : BotImpactPanel,
        },
        {
          path: 'journey',
          name: 'journey_reports',
          meta: { ...meta, emBreveTitulo: 'Jornada do torcedor' },
          component: gated ? EmBreve : JourneyPanel,
        },
        {
          path: 'satisfacao',
          name: 'satisfacao_reports',
          meta: { ...meta, emBreveTitulo: 'Satisfação' },
          component: gated ? EmBreve : SatisfacaoPanel,
        },
        {
          path: 'pendencia',
          name: 'pendencia_reports',
          meta: { ...meta, emBreveTitulo: 'Pendência por parceiro' },
          component: gated ? EmBreve : PendenciaPanel,
        },
        {
          // T-291: presença do agente · entrada, saída e tempo em cada estado.
          path: 'presenca',
          name: 'presenca_reports',
          meta: { ...meta, emBreveTitulo: 'Presença do agente' },
          component: gated ? EmBreve : PresencaPanel,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        {
          // T-151: agente, time, caixa de entrada e etiqueta numa página só, com seletor.
          path: 'quebras',
          name: 'quebras_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: QuebrasPanel,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          // T-150h: o CSAT virou aba de Satisfação.
          path: 'csat',
          name: 'csat_reports',
          redirect: to => ({
            name: 'satisfacao_reports',
            params: to.params,
            query: { aba: 'respostas' },
          }),
        },
        {
          // T-150g: o relatório nativo do bot virou aba de Atendimento IA.
          path: 'bot',
          name: 'bot_reports',
          redirect: to => ({
            name: 'bot_impact_reports',
            params: to.params,
            query: { aba: 'nativo' },
          }),
        },
      ],
    },
  ],
};
